

























































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import {
  getdatalist,
  adddata,
  getinfodata,
  updateinfo,
  getorginizlist,
  uploadfile,
  gettissuelist,
} from "@/api/examineeManage";
import Pagination from "@/components/Pagination/index.vue";
import eltree from "@/views/examineeManage/index.vue";

@Component({
  name: "examineeManage",
  components: { Pagination },
})
export default class extends Vue {
  [x: string]: any;
  // [x: string]: any;
  mounted() {
    const everyogrid = this.getsession().orgnizeid.split(",");
    let object: any = [];
    everyogrid.forEach((res) => {
      object.push(res);
    });
    let listquerOrgid = {
      id: object.join(","),
    };
    this.baseurl = (window as any).baseurl;

    this.listQuery.organid.push(listquerOrgid);
    this.getList(this.listQuery);
    this.getztreelist();
    this.showstudenttype();
  }
  @Watch("orgnaztype")
  changemenu() {
    ++this.isResourceshow;
  }
  private currtentpage = 1;
  private total: number = 0;
  private formObj = {
    dialogVisible: false,
    title: "",
  };
  // private options = [
  //   {
  //     key: "启用",
  //     value: 1,
  //   },
  //   {
  //     key: "禁用",
  //     value: 0,
  //   },
  // ];
  private tableData = {};
  private baseurl = "";
  private currentPage: number = 1;
  private value: boolean = true;
  private isloading = true;
  private orgnaztype: any = []; //级联选择器数据源
  private eltreelist: any = []; //z-tree的数据源
  private caseidlist: any = []; //修改学生回显得列表
  private taglistarray: any = [];
  private multipleSelection: any = [];
  private tagdisplay = "none";
  private isResourceshow = 0;
  private uploadloading = false;
  private fileSizeIsSatisfy = [];
  private diaparms = {
    updiaupload: false,
  };
  private uploadform = {};
  private addParams: any = {
    addStudentList: [
      {
        age: "",
        identity: "",
        name: "",
        organid: [],
        sex: "",
        type: "",
      },
    ],
  };
  private defaultProps = {};
  private sexoptions = [
    {
      label: "男",
      value: 0,
    },
    {
      label: "女",
      value: 1,
    },
    {
      label: "性别不详",
      value: 2,
    },
  ];
  private options = [{}];
  private editparms: any = {
    addStudentList: [
      {
        id: "",
      },
    ],
  };
  private listQuery: any = {
    limit: 10,
    name: "",
    organid: [],
    page: 1,
    isSelf: 1, //0包括本身 1不包括
  };
  private ztreeprops = {
    label: "label",
    value: "value",
    pid: "pid",
    // children: "zones",
    isLeaf: "leaf",
  };
  // 表单校验规则
  private rules = {
    addStudentList: [
      {
        name: [
          { required: true, message: "请输入学生姓名", trigger: "blur" },
          // { min: 3, max: 5, message: "长度在 3 到 5 个字符", trigger: "blur" },
        ],
        organid: [
          { required: true, message: "请选择学生所属组织", trigger: "change" },
        ],
        identity: [
          { required: true, message: "请填写证件号码", trigger: "blur" },
          {
            pattern: /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}$)/,
            message: "证件号码格式有误！",
            trigger: "blur",
          },
        ],
        isuse: [
          { required: true, message: "请选择使用状态", trigger: "change" },
        ],
      },
    ],
  };
  // 显示学生类型
  private showstudenttype() {
    const orglength = this.getsession().orgnizeid.split(",").length;
    if (orglength == 1) {
      this.options = [
        { label: "军级学生", value: 0 },
        { label: "旅级学生", value: 1 },
        { label: "营级学生", value: 2 },
        { label: "连级学生", value: 3 },
        { label: "排级学生", value: 4 },
        { label: "班级学生", value: 5 },
      ];
    } else if (orglength == 2) {
      this.options = [
        { label: "旅级学生", value: 1 },
        { label: "营级学生", value: 2 },
        { label: "连级学生", value: 3 },
        { label: "排级学生", value: 4 },
        { label: "班级学生", value: 5 },
      ];
    } else if (orglength == 3) {
      this.options = [
        { label: "营级学生", value: 2 },
        { label: "连级学生", value: 3 },
        { label: "排级学生", value: 4 },
        { label: "班级学生", value: 5 },
      ];
    }
  }
  // 上传评分表
  private uploaduserfile() {
    this.diaparms.updiaupload = true;
    this.fileSizeIsSatisfy = [];
  }
  private handleSelectionChange(val: any) {
    this.multipleSelection = val;
  }
  // // 文件上传
  // private handleExceed(file: any, fileList: any) {
  //   this.$message.warning(`当前限制上传 1 个文件`);
  // }
  private fileOnChange(file: any) {
    let that: any = this;
    that.fileSizeIsSatisfy.push(file.raw);
  }
  private fileBeforeRemove(file: any, fileList: any) {
    this.fileSizeIsSatisfy = fileList;
  }

  private async uploadfomrfile() {
    this.uploadloading = true;
    const formdata = new FormData();
    this.fileSizeIsSatisfy.forEach((res) => {
      formdata.append("file", res);
    });
    await uploadfile(formdata).then((res) => {
      if (res.code === 200) {
        this.uploadloading = false;
        this.diaparms.updiaupload = false;
        this.$message.success("导入成功");
        this.getList(this.listQuery);
      } else if (res.code === 201) {
        this.$message.warning(res.message);
        this.uploadloading = false;
      }
    });
  }

  // 获取sessionstorage
  private getsession() {
    let parm = sessionStorage.getItem("json");
    let parma: any = null;
    if (parm != null) {
      parma = JSON.parse(parm);
    }
    return parma;
    // this.addParams.orgnizeid = parma.orgnizeid;
  }
  // 获取列表
  private async getList(params: any) {
    await getdatalist(params)
      .then((res) => {
        if (res.code === 200) {
          this.isloading = false;
          this.tableData = res.data;
          this.total = res.data.total;
          this.listLoading = false;
        }
      })
      .catch(() => {
        // this.list = [];
        // this.listLoading = false;
      });
  }
  // 删除学生数据
  private async deletedata(params: any) {
    this.editparms.isdelete = 0;
    this.editparms.id = params.id;
    this.$confirm("确定要删除这条学生数据吗?", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    }).then(async () => {
      await updateinfo(this.editparms).then((res: any) => {
        if (res.code === 200) {
          this.$message({
            type: "success",
            message: "删除成功!",
          });
          this.getList(this.listQuery);
          this.editparms = {
            name: "",
            description: "",
            isuse: "",
            id: "",
            isdelete: 1,
          };
        } else {
          this.$message({
            message: "删除失败",
            type: "warning",
          });
        }
      });
    });
  }
  private async getorginlist() {
    const param = {
      organid: this.getsession().orgnizeid.split(",").pop(),
    };
    await getorginizlist(param).then((res) => {
      if (res.code === 200) {
        res.data.forEach((res) => {
          this.orgnaztype.push({
            value: res.id,
            label: res.label,
            children: [],
          });
        });
      }
    });
  }
  //  获取ztreelist
  private async getztreelist() {
    const param = {
      id: this.getsession().orgnizeid.split(",").pop(),
    };
    await gettissuelist(param).then((res) => {
      if (res.code === 200) {
        this.eltreelist = this.getTree(res.data);
        this.orgnaztype = this.getTree(res.data);
      }
    });
  }
  private checkchange(data, node) {
    console.log(node);
  }
  // 递归遍历树结构数据获取树结构得父组织id
  private arrlist(idlist, node) {
    idlist.push(node.data.value);

    if (node.parent !== null) {
      this.arrlist(idlist, node.parent);
    } else {
      return idlist;
    }
  }
  // z-tree点击显示tags
  private handleNodeClick(data, node) {
    let orgidlist: any = [];
    this.listQuery.organid = [];
    this.arrlist(orgidlist, node);
    orgidlist =
      this.getsession().orgnizeid +
      "," +
      orgidlist
        .slice(0, orgidlist.length - 1)
        .reverse()
        .join(",");
    this.listQuery.organid.push({
      id: orgidlist,
    });
    this.listQuery.isSelf = 0;
    this.getList(this.listQuery);
  }
  private changetype() {
    this.addParams.addStudentList[0].organid = "";
    this.orgnaztype = [];
    // console.log(this.orgnaztype);
    // ++this.isResourceshow;
    this.getorginlist();
  }

  private onSubmit() {
    this.getList(this.listQuery);
  }
  private clearSearch() {
    this.listQuery.organid = [];
    this.listQuery.name = "";
    this.listQuery.isSelf = 1;
    this.tagdisplay = "none";
    const everyogrid = this.getsession().orgnizeid.split(",");
    everyogrid.forEach((res) => {
      const id_ = {
        id: res,
      };
      this.listQuery.organid.push(id_);
    });
    this.getList(this.listQuery);
  }

  private onCreatItem() {
    this.formObj.title = "新增学生";
    // this.orgnaztype = [];
    this.formObj.dialogVisible = true;
    this.getztreelist();
    this.$nextTick(() => {
      (this.$refs.ruleForm as any).resetFields();
      this.addParams = {
        addStudentList: [
          {
            age: "",
            identity: "",
            name: "",
            organid: [],
            sex: "",
            type: "",
          },
        ],
      };
    });
  }
  private closecasca() {
    this.addParams.addStudentList[0].organid == [];
    this.orgnaztype = [];
    // console.log(this.orgnaztype);
    // ++this.isResourceshow;
    this.getorginlist();
  }
  // 递归处理cascader绑定数据源，回显数据
  private handleProps(arr: any) {
    if (arr.length != 0) {
      const result = {};
      let cur: any = result;
      const orginizelist: any = [];
      const index = this.getsession().orgnizeid.split(",");
      for (let i in arr) {
        if (arr[i].organId !== index[i]) {
          orginizelist.push(arr[i]);
        }
      }
      orginizelist.forEach((item, index) => {
        cur.label = item.name;
        cur.value = item.organId;
        if (index !== orginizelist.length - 1) {
          cur.children = [{}];
          cur = cur.children[0];
        }
      });
      this.orgnaztype.push(result);
    }
  }
  private async editItem(params: any) {
    const parm = { id: params };

    this.getztreelist();
    this.formObj.title = "编辑学生";
    // this.$nextTick(() => {
    //   (this.$refs.ruleForm as any).resetFields();
    // });
    // this.getorginlist();
    await getinfodata(parm).then((res: any) => {
      if (res.code === 200) {
        this.isloading = false;
        const { data } = res;
        // this.handleProps(data.organIdLists);

        let datalist = res.data.organIdLists;
        const caseidlist: any = [];
        for (let i in datalist) {
          caseidlist.push(datalist[i].organId);
        }
        let index = this.getsession().orgnizeid.split(",").length;
        let newOgrid = caseidlist.splice(index);
        console.log(newOgrid);
        this.addParams = {
          addStudentList: [
            {
              type: data.type,
              age: data.age,
              identity: data.identity,
              name: data.name,
              organid: newOgrid,
              sex: data.sex,
            },
          ],
        };

        this.editparms = {
          addStudentList: [
            {
              id: data.id,
            },
          ],
        };
      }
    });
    this.formObj.dialogVisible = true;
  }
  private getTree(array: any) {
    return array.map((v) => {
      const item: any = {
        value: v.id, //这是创建的新对象 根据需要的键随意更改
        label: v.name,
      };
      if (v.children) item.children = this.getTree(v.children);
      return item;
    });
  }
  // 加载z-tree的方法
  private loadztreeNode(node, resolve) {
    if (node.level === 0) {
      return resolve(this.eltreelist);
    }
    // if (node.level > 1) return resolve([]);
    setTimeout(async () => {
      const params = {
        organid: node.data.value,
      };
      let nodes;
      await getorginizlist(params).then((res) => {
        if (res.code === 200) {
          nodes = res.data.map((item) => ({
            value: item.id,
            label: item.label,
            pid: item.pid,
            children: [],
          }));
          resolve(nodes);
        }
      });
    }, 500);
  }
  private handleClose(done: any) {
    this.formObj.dialogVisible = false;
    this.diaparms.updiaupload = false;
    // this.addParams = {
    //   name: "",
    //   description: "",
    //   isuse: "",
    // };
  }

  private async subMitData() {
    const form = this.$refs.ruleForm as any;
    form.validate((valid: boolean) => {
      if (valid) {
        if (this.editparms.addStudentList[0].id !== "") {
          let orgid = (this.addParams.addStudentList[0].organid = this.addParams.addStudentList[0].organid);
          let orgparam = this.getsession().orgnizeid.split(",");
          this.addParams.addStudentList[0].organid =
            orgparam.slice(0, orgparam.length - 1).join(",") +
            "," +
            orgid.join(",");
          this.editparms = {
            updateInfoList: [
              {
                id: this.editparms.addStudentList[0].id,
                type: this.addParams.addStudentList[0].type,
                age: this.addParams.addStudentList[0].age,
                identity: this.addParams.addStudentList[0].identity,
                name: this.addParams.addStudentList[0].name,
                organid: this.addParams.addStudentList[0].organid,
                sex: this.addParams.addStudentList[0].sex,
                isdelete: 1,
                isuse: 0,
              },
            ],
          };

          updateinfo(this.editparms).then((res) => {
            if (res.code === 200) {
              this.formObj.dialogVisible = false;
              form.resetFields();
              this.$message.success("修改成功");
              this.getList(this.listQuery);
              this.editparms = {};
            }
          });
        } else {
          // 所属组织id=当前角色的组织id+新增选择的下级组织id
          let orgid = (this.addParams.addStudentList[0].organid = this.addParams.addStudentList[0].organid);
          let orgparam = this.getsession().orgnizeid.split(",");
          this.addParams.addStudentList[0].organid =
            orgparam.slice(0, orgparam.length - 1).join(",") +
            "," +
            orgid.join(",");
          console.log(this.addParams);
          // adddata(this.addParams).then((res) => {
          //   if (res.code === 200) {
          //     form.resetFields();
          //     this.$message.success("添加成功");
          //     this.getList(this.listQuery);
          //     this.formObj.dialogVisible = false;
          //   } else if (res.code === 201) {
          //     this.$message.warning("该考生已存在");
          //   }
          // });
        }
      } else {
        return false;
      }
    });
  }
  // 分页
  private handleSizeChange(val: number) {
    this.listQuery.limit = val;
    this.getList(this.listQuery);
  }
  private handleCurrentChange(val: number) {
    this.listQuery.page = val;
    this.getList(this.listQuery);
  }
  private cellStyle({
    row,
    column,
    rowIndex,
    columnIndex,
  }: {
    row: any;
    column: any;
    rowIndex: any;
    columnIndex: any;
  }) {
    return "text-align:center";
  }

  private rowClass({ row, rowIndex }: { row: any; rowIndex: any }) {
    return "text-align:center";
  }
}
